import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { isCodesmithExtensionEmbed } from "@/lib/codesmithExtensionEmbed";
import { parseCodesmithExtensionHistoryRequest, postCodesmithExtensionHistoryState, traverseNavigation, windowNavigation } from "@/lib/codesmithExtensionHistory";
export function useCodesmithExtensionHistoryBridge() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
}
function _temp() {
  if (!isCodesmithExtensionEmbed(new URLSearchParams(location.search).get("embed") ?? undefined)) {
    return;
  }
  const navigation = windowNavigation();
  if (!navigation) {
    return;
  }
  const reportState = () => postCodesmithExtensionHistoryState(navigation);
  const handleMessage = event => {
    const direction = parseCodesmithExtensionHistoryRequest(event);
    if (direction !== null) {
      traverseNavigation(navigation, direction);
    }
  };
  reportState();
  navigation.addEventListener("currententrychange", reportState);
  window.addEventListener("message", handleMessage);
  return () => {
    navigation.removeEventListener("currententrychange", reportState);
    window.removeEventListener("message", handleMessage);
  };
}